import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, Inject, OnInit  } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ApproveOrRejectGQL } from '../../../../generated/gatewaygql';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticationService } from './../../../../services/authentication.service';
import { HeaderTemplateData } from '../dialog-data.interface';

export interface DialogData {
    title: string;
    item: any;
    action: string;
    todoType: string;
    header: HeaderTemplateData;
}

@Component({
    selector: 'app-remark-dialog',
    templateUrl: './remark-dialog.html',
})
export class RemarkDialogComponent implements OnInit {
    result: DialogData;
    form: FormGroup;
    remark: string;
    userId: number;
    propertyId: number;
    isClicked = false;
    btnConfirmTxt = "Confirm";
    header: HeaderTemplateData

    constructor(
        public dialogRef: MatDialogRef<RemarkDialogComponent>,

        // private
        @Inject(MAT_DIALOG_DATA) private _data: DialogData,
        private _fb: FormBuilder,
        private approveOrRejectGQL: ApproveOrRejectGQL,
        private _snackBar: MatSnackBar,
        private _authService: AuthenticationService,
    ) {

        if (_data != null) {
            this.result = _data;
            this.header = _data.header;
        }

    }

    ngOnInit() {
        this.userId = this._authService.userContext.lUserId;
        this.propertyId = this._authService.userInfo.property.propertyId;
        this.form = this._fb.group({
            remark: ['', Validators.required]
        });
    }

    onSubmit(item: any, event: any) {
        this.isClicked = true;

        if (this.form.value.remark.length > 0) {

            this.remark = this.form.value.remark;

            //let appOrRejectResult = 
            this.approveOrRejectGQL.mutate({
                TodoRecord: this.result.item,
                Action: this.result.action,
                UserId: this.userId = this._authService.userContext.lUserId,
                Remark: this.remark,
                TodoType: this.result.todoType
            }).subscribe(x => {
                this.dialogRef.close(x.data.ApproveOrReject);
            });
        }

    }
}
